import { render, staticRenderFns } from "./Peppermint.vue?vue&type=template&id=63c8245c&scoped=true&"
import script from "./Peppermint.vue?vue&type=script&lang=js&"
export * from "./Peppermint.vue?vue&type=script&lang=js&"
import style0 from "./Peppermint.vue?vue&type=style&index=0&id=63c8245c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c8245c",
  null
  
)

export default component.exports